import React from 'react'
import { DasaProvider } from '@dasa-health/components-react'
import { Route, RouteComponentProps, RouteProps, Switch } from 'react-router-dom'
import { Paths } from '@nsw-paginas-deslogadas/constants'
import ContextRoute from './ContextRoute'
import { LandingPage } from '@nsw-paginas-deslogadas/pages'

export type QueryParams = {
    brand: string
    productId: string
    productName: string
}

const RouterContext: React.FC<RouteProps & { component: React.FC }> = ({ component, ...props }) => {
    const render = (routeComponentProps: RouteComponentProps<QueryParams>) => {
        return <ContextRoute {...routeComponentProps} component={component} />
    }
    return <Route {...props} render={render} />
}

const Routes: React.FC = () => {
    return (
        <DasaProvider>
            <Switch>
                <RouterContext component={LandingPage} exact path={[Paths.laboratory, Paths.landingPageBrand]} />
            </Switch>
        </DasaProvider>
    )
}

export default Routes
